// extracted by mini-css-extract-plugin
module.exports = {"search":"SearchBar_search__1vBdt","input":"SearchBar_input__2Y93q"};